<template>
  <div class="legend-title text--primary">
    <i :class="`fa-${iconName}`" class="fas legend-title__icon" />
    <span class="text-legend legend-title__text">{{ title }}:</span>
  </div>
</template>

<script>
export default {
  name: 'LegendTitle',
  props: {
    iconName: String,
    title: {
      type: String,
      default: 'Label',
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-title {
  &__icon {
    display: inline;
    font-size: 12px;
    margin-right: 5px;
  }

  &__text {
    display: inline;
  }
}
</style>
